module.exports = __webpack_public_path__ + "img/ClickForSound_35.9d454a7a.png";